var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: ["icon-arrow", _vm.modClass] }, [
    _vm.type === "thin"
      ? _c(
          "svg",
          { attrs: { width: "16", height: "12", viewBox: "0 0 16 12" } },
          [
            _c("path", {
              attrs: {
                d: "M9.8.4l-.7.7 4.4 4.4H.5v1h13.2l-4.4 4.4.7.7 5.5-5.5z"
              }
            })
          ]
        )
      : _c(
          "svg",
          { attrs: { width: "16", height: "12", viewBox: "0 0 16 12" } },
          [
            _c("path", {
              attrs: {
                d: "M9.8 0L8.4 1.4 12 5H.1v2h12.1l-3.6 3.6L10 12l5.9-5.9z"
              }
            })
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2227f845", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2227f845","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/IconArrow.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2227f845","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/IconArrow.vue
// module chunks = 5